var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VDataTable',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'VDataTable',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }